<template>
    <div class="automation-trigger-settings">
        <p>
            {{
                t(
                    "automations-form-triggers_config-task_moved_to_column-description",
                )
            }}
        </p>

        <div class="field">
            <label :class="{ label: true, 'label-danger': !boardId }">
                {{
                    t(
                        "automations-form-triggers_config-task_moved_to_column-board_label",
                    )
                }}
            </label>
            <select class="form-control" v-model="boardId">
                <option value="">
                    {{
                        t(
                            "automations-form-triggers_config-task_moved_to_column-board_placeholder",
                        )
                    }}
                </option>
                <option
                    v-for="board in boards"
                    :key="board.id"
                    :value="String(board.id)"
                >
                    {{ board.name }}
                </option>
            </select>
        </div>

        <div class="field" v-if="boardId">
            <label :class="{ label: true, 'label-danger': !selected.length }">
                {{
                    t(
                        "automations-form-triggers_config-task_moved_to_column-column_label",
                    )
                }}
            </label>
            <div
                class="column-options"
                v-if="selectedBoardColumns.length"
            >
                <label
                    class="column-option"
                    v-for="column in selectedBoardColumns"
                    :key="column.id"
                >
                    <input
                        type="checkbox"
                        :value="String(column.id)"
                        v-model="selected"
                    />
                    {{ column.name }}
                </label>
            </div>
            <small v-else class="text-muted">
                {{
                    t(
                        "automations-form-triggers_config-task_moved_to_column-no_columns",
                    )
                }}
            </small>
        </div>
    </div>
</template>

<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        const first = this.value && this.value.length ? this.value[0] : {};
        return {
            boards: [],
            boardId: first.boardId ? String(first.boardId) : "",
            selected: Array.isArray(first.selected)
                ? first.selected.map((id) => String(id))
                : [],
        };
    },
    computed: {
        selectedBoardColumns() {
            const board = this.boards.find(
                (item) => String(item.id) === String(this.boardId),
            );
            return board && board.columns ? board.columns : [];
        },
    },
    mounted() {
        this.loadBoards();
        this.changed();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        loadBoards() {
            const options = keviApi.getOptions("/task-boards-columns", "GET");
            this.$http(options).then((response) => {
                this.boards = response.body || response.data || [];
            });
        },
        changed() {
            this.$emit("input", [
                {
                    boardId: this.boardId || null,
                    selected: this.selected,
                },
            ]);
        },
        isValid() {
            return !!(this.boardId && this.selected.length);
        },
    },
    watch: {
        boardId(newId, oldId) {
            if (String(newId) !== String(oldId)) {
                const validIds = this.selectedBoardColumns.map((column) =>
                    String(column.id),
                );
                this.selected = this.selected.filter((id) =>
                    validIds.includes(String(id)),
                );
            }
            this.changed();
        },
        selected() {
            this.changed();
        },
        value(val) {
            const first = val && val.length ? val[0] : {};
            const boardId = first.boardId ? String(first.boardId) : "";
            const selected = Array.isArray(first.selected)
                ? first.selected.map((id) => String(id))
                : [];
            if (
                boardId !== this.boardId ||
                JSON.stringify(selected) !== JSON.stringify(this.selected)
            ) {
                this.boardId = boardId;
                this.selected = selected;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.column-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
}

.column-option {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 400;
    margin: 0;
    cursor: pointer;
}
</style>
